module.exports = __webpack_public_path__ + "img/screen_iphone2.b4afbc05.png";